import { render, staticRenderFns } from "./ProductoActivo.vue?vue&type=template&id=08fc3f18"
import script from "./ProductoActivo.vue?vue&type=script&lang=js"
export * from "./ProductoActivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports